import endPoints from 'widget/api/endPoints';
import { API } from 'widget/helpers/axios';

const sendMessageAPI = async ({ contact, content, conversationId, ticketTypeId, ticketTypeFields, priority, accountId }) => {
  const urlData = endPoints.sendMessage({ contact, content, conversationId, ticketTypeId, ticketTypeFields, priority, accountId });
  return API.post(urlData.url, urlData.params);
};

const sendAttachmentAPI = async ({ attachment, conversationId }) => {
  const urlData = endPoints.sendAttachment({ attachment, conversationId });
  return API.postForm(urlData.url, urlData.params);
};

const getMessagesAPI = async ({ before, conversationId }) => {
  const urlData = endPoints.getConversation({ before, conversationId });
  return API.get(urlData.url, { params: urlData.params });
};

const getMessageAPI = async ({ id }) => {
  const urlData = endPoints.getMessage({ id });

  return API.get(urlData.url);
};

const getConversationAPI = async () => {
  return API.get(`/api/widget/conversations`);
};

const getConversationsListAPI = async ({ before, filter, conversationId }) => {
  return API.get(`/api/widget/conversations`, {
    params: {
      version: 2,
      before,
      filter: filter ? JSON.stringify(filter) : undefined,
      conversation_id: conversationId,
    }
  });
};

const filterCustomFields = async (form) => {
  return API.post('/api/widget/custom-fields', form);
}

const toggleTyping = async ({ typingStatus }) => {
  return API.post(
    `/api/widget/conversations/toggle-typing`,
    { typing_status: typingStatus }
  );
};

const setUserLastSeenAt = async ({ lastSeen }) => {
  return API.post(
    `/api/widget/conversations/update-last-seen`,
    { contact_last_seen_at: lastSeen }
  );
};
const sendEmailTranscript = async ({ email }) => {
  return API.post(
    `/api/widget/conversations/transcript`,
    { email }
  );
};
const toggleStatus = async () => {
  return API.get(
    `/api/widget/conversations/toggle-status`
  );
};

export {
  sendMessageAPI,
  getConversationAPI,
  getConversationsListAPI,
  getMessagesAPI,
  getMessageAPI,
  sendAttachmentAPI,
  filterCustomFields,
  toggleTyping,
  setUserLastSeenAt,
  sendEmailTranscript,
  toggleStatus,
};
